import * as integrationsDatasetsCommands from '@Integrations/Datasets/commands-vue-composables'
import * as integrationsDatasetsQueries from '@Integrations/Datasets/queries-vue-composables'
import * as integrationsUsersQueries from '@Integrations/Users/queries-vue-composables'

export function useAdminDatasetsDetailsPage(){
	return {
		useClearDatasetItemsCommand: integrationsDatasetsCommands.useClearDatasetItemsCommandV1,
		useCurrentUserQuery: integrationsUsersQueries.useCurrentUserQueryV1,
		useDatasetChangeLogQueryV1: integrationsDatasetsQueries.useDatasetChangeLogQueryV1,
		useDatasetDetailsQuery: integrationsDatasetsQueries.useDatasetDetailsQueryV1,
		useDeleteDatasetCommand: integrationsDatasetsCommands.useDeleteDatasetCommandV1,
		usePermanentDeleteDatasetCommand: integrationsDatasetsCommands.usePermanentDeleteDatasetCommandV1,
	}
}

export function useAdminManageDatasetsPage(){
	return {
		useCreateDatasetCommand: integrationsDatasetsCommands.useCreateDatasetCommandV1,
		useCurrentUserQuery: integrationsUsersQueries.useCurrentUserQueryV1,
		useDatasetsOfOrganizationQuery: integrationsDatasetsQueries.useDatasetsOfOrganizationQueryV1,
	}
}

